import { startOfDay } from 'date-fns';

interface Event {
  start: string | Date | null;
}

export interface EventsGroupedByDate<T> {
  date: Date;
  events: T[];
}

// group events by date and sort by soonest (including inner events)
export function groupEventsByDate<T extends Event>(
  eventsToGroup: T[],
): Array<EventsGroupedByDate<T>> {
  const eventsGroupedByDate: Array<EventsGroupedByDate<T>> = [];
  if (!eventsToGroup || eventsToGroup.length === 0) {
    return [];
  }

  eventsToGroup.forEach((event) => {
    if (!event?.start) {
      return;
    }

    const startDate =
      typeof event.start === 'string' ? new Date(event.start) : event.start;

    const startOfDate = startOfDay(startDate);

    const matchingGroupedDate = eventsGroupedByDate.find((eventGroup) => {
      return eventGroup.date.getTime() === startOfDate.getTime();
    });

    if (matchingGroupedDate) {
      matchingGroupedDate.events.push(event);
      return;
    }

    eventsGroupedByDate.push({ date: startOfDate, events: [event] });
  });

  return eventsGroupedByDate
    .map((eventGroup) => {
      return {
        ...eventGroup,
        events: eventGroup.events.sort((a, b) => {
          return (
            new Date(a?.start || '').getTime() -
            new Date(b?.start || '').getTime()
          );
        }),
      };
    })
    .sort((a, b) => {
      return a.date.getTime() - b.date.getTime();
    });
}
